import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../../Radio'
import { EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE } from '../EmailCreationForm.constants'

import { EMAIL_SELECT_TEMPLATE_TO_TEST_INITIAL_VALUES } from './EmailSelectTemplateToTestVariablesModal.constants'
import { getOptions } from './EmailSelectTemplateToTestVariablesModal.utils'

function EmailSelectTemplateToTestVariablesModal(props) {
  const { t } = useTranslation()

  return (
    <RadioGroupModal
      {...props}
      formFieldsProps={{
        getOptions,
        name: EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE,
        submitProps: {
          title: 'Modal.TestVariablesBtnKey',
        },
        title: t('Modal.SelectTemplateTypeConfirmationModalText'),
      }}
      initialValues={EMAIL_SELECT_TEMPLATE_TO_TEST_INITIAL_VALUES}
      title={t('Modal.TestVariablesConfirmationModalTitle')}
    />
  )
}

export default EmailSelectTemplateToTestVariablesModal
